import HistoryItem from './HistoryItem'

export default HistoryItem
